export default "__VITE_ASSET__Br3abu43__"